// deserializers/extension.deserializer.js
import { Deserializer } from 'jsonapi-serializer';

// Instantiate deserializer configured to keep snake_case
const extensionDeserializerInstance = new Deserializer({
  keyForAttribute: 'camelCase'
});

/**
 * Deserializes a JSON:API response back into plain JavaScript objects,
 * automatically stitching included relationships (like metadata) back onto each record.
 * 
 * @param {Object} jsonApiPayload - The raw JSON:API response from the Express backend
 * @returns {Promise<Array|Object>} Plain JS object or array of objects matching the original DB format
 */
export const deserializeExtensions = async (jsonApiPayload) => {
  if (!jsonApiPayload) return null;
  return await extensionDeserializerInstance.deserialize(jsonApiPayload);
};